(function () {
  function getEls() {
    return {
      container: document.querySelector('#AjaxinateContainer'),
      pagination: document.querySelector('#AjaxinatePagination'),
    };
  }

  function watchAjaxinateDom() {
    var lastSig = null;
    var timer = null;

    function signature() {
      var pag = document.querySelector('#AjaxinatePagination');
      var a = pag && pag.querySelector('a[href]');
      // include href + link text because some themes keep href but swap content
      return a ? (a.getAttribute('href') + '|' + (a.textContent || '').trim()) : null;
    }

    function scheduleInit() {
      clearTimeout(timer);
      timer = setTimeout(function () {
        initWithRetry(20);
      }, 80);
    }

    // Observe the whole document so we survive any node replacement
    var obs = new MutationObserver(function () {
      var sig = signature();
      if (sig && sig !== lastSig) {
        lastSig = sig;
        scheduleInit();
      }
    });

    obs.observe(document.body, { childList: true, subtree: true });

    // Prime lastSig on startup
    lastSig = signature();
  }



  function hasNextLink(pagination) {
    return !!(pagination && pagination.querySelector('a[href]'));
  }

  function resetPaginationNode() {
    var pag = document.querySelector('#AjaxinatePagination');
    if (!pag || !pag.parentNode) return;
    var clone = pag.cloneNode(true); // drops any old listeners
    pag.parentNode.replaceChild(clone, pag);

  }

  function initAjaxinate() {
    if (typeof Ajaxinate === 'undefined') return false;

    var els = getEls();
    if (!els.container || !els.pagination) return false;
    if (!hasNextLink(els.pagination)) return false;

    // already bound on this specific pagination node
    if (els.pagination.dataset.ajaxinateBound === 'true') return true;

    // hard reset pagination node so we never accumulate handlers
    resetPaginationNode();

    // re-select after replacement
    els = getEls();
    if (!els.pagination || !hasNextLink(els.pagination)) return false;

    if (window.ajaxinateInstance && typeof window.ajaxinateInstance.destroy === 'function') {
      window.ajaxinateInstance.destroy();
    }

    window.ajaxinateInstance = new Ajaxinate({
      container: '#AjaxinateContainer',
      pagination: '#AjaxinatePagination',
      method: 'click',
      loadingText: 'Loading…'
      //   callback: function () {
      //   document.dispatchEvent(new CustomEvent('swym:collections-loaded'));
      // }
    });


    els.pagination.dataset.ajaxinateBound = 'true';
    return true;
  }

  // Retry because on filter reload the pagination/link may not exist yet when section:load fires
  function initWithRetry(tries) {
    if (initAjaxinate()) return;
    if (tries <= 0) return;
    setTimeout(function () { initWithRetry(tries - 1); }, 60);
  }

  document.addEventListener('DOMContentLoaded', function () {
    watchAjaxinateDom();
    initWithRetry(10);
  });

  document.addEventListener('shopify:section:load', function () {
    initWithRetry(10);
  });
})();
